import * as React from 'react';
import { Form, Input, Label } from 'semantic-ui-react';

interface Props {
    input: {
        value: any;
        onChange: any;
        type?: string;
    };
    label?: string;
    options?: React.ReactNode;
    meta: {
        touched?: boolean;
        error?: string;
    };
    nullOnUnmount?: boolean;
    name: string;
    inputProps?: Record<string, string>;
}

export class RenderFileUpload extends React.PureComponent<Props> {
    // eslint-disable-next-line react/static-property-placement
    static defaultProps = {
        nullOnUnmount: true
    };

    componentWillUnmount(): void {
        const { input, nullOnUnmount } = this.props;
        if (nullOnUnmount) {
            input.onChange(null);
        }
    }

    handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { input } = this.props;
        const file = event.target.files && event.target.files[0];
        input.onChange(file);
    };

    render(): React.ReactElement {
        const {
            input: { value, ...input },
            label,
            meta: { touched, error },
            options,
            nullOnUnmount,
            name,
            inputProps,
            ...props
        } = this.props;

        const inputComponent = (
            <Input
                type="file"
                name={name}
                {...input}
                {...props}
                onChange={this.handleFileChange}
            />
        );

        return (
            <Form.Field
                style={{ position: 'relative' }}
                error={!!(touched && error)}
            >
                {label && <label htmlFor={name}>{label}</label>}
                {options}
                {inputComponent}
                {!!(touched && error) && (
                    <Label basic color="red" pointing>
                        {error}
                    </Label>
                )}
            </Form.Field>
        );
    }
}

export default RenderFileUpload;
